// jQuery template
(function(a){var r=a.fn.domManip,d="_tmplitem",q=/^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /,b={},f={},e,p={key:0,data:{}},h=0,c=0,l=[];function g(e,d,g,i){var c={data:i||(d?d.data:{}),_wrap:d?d._wrap:null,tmpl:null,parent:d||null,nodes:[],calls:u,nest:w,wrap:x,html:v,update:t};e&&a.extend(c,e,{nodes:[],parent:d});if(g){c.tmpl=g;c._ctnt=c._ctnt||c.tmpl(a,c);c.key=++h;(l.length?f:b)[h]=c}return c}a.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(f,d){a.fn[f]=function(n){var g=[],i=a(n),k,h,m,l,j=this.length===1&&this[0].parentNode;e=b||{};if(j&&j.nodeType===11&&j.childNodes.length===1&&i.length===1){i[d](this[0]);g=this}else{for(h=0,m=i.length;h<m;h++){c=h;k=(h>0?this.clone(true):this).get();a.fn[d].apply(a(i[h]),k);g=g.concat(k)}c=0;g=this.pushStack(g,f,i.selector)}l=e;e=null;a.tmpl.complete(l);return g}});a.fn.extend({tmpl:function(d,c,b){return a.tmpl(this[0],d,c,b)},tmplItem:function(){return a.tmplItem(this[0])},template:function(b){return a.template(b,this[0])},domManip:function(d,l,j){if(d[0]&&d[0].nodeType){var f=a.makeArray(arguments),g=d.length,i=0,h;while(i<g&&!(h=a.data(d[i++],"tmplItem")));if(g>1)f[0]=[a.makeArray(d)];if(h&&c)f[2]=function(b){a.tmpl.afterManip(this,b,j)};r.apply(this,f)}else r.apply(this,arguments);c=0;!e&&a.tmpl.complete(b);return this}});a.extend({tmpl:function(d,h,e,c){var j,k=!c;if(k){c=p;d=a.template[d]||a.template(null,d);f={}}else if(!d){d=c.tmpl;b[c.key]=c;c.nodes=[];c.wrapped&&n(c,c.wrapped);return a(i(c,null,c.tmpl(a,c)))}if(!d)return[];if(typeof h==="function")h=h.call(c||{});e&&e.wrapped&&n(e,e.wrapped);j=a.isArray(h)?a.map(h,function(a){return a?g(e,c,d,a):null}):[g(e,c,d,h)];return k?a(i(c,null,j)):j},tmplItem:function(b){var c;if(b instanceof a)b=b[0];while(b&&b.nodeType===1&&!(c=a.data(b,"tmplItem"))&&(b=b.parentNode));return c||p},template:function(c,b){if(b){if(typeof b==="string")b=o(b);else if(b instanceof a)b=b[0]||{};if(b.nodeType)b=a.data(b,"tmpl")||a.data(b,"tmpl",o(b.innerHTML));return typeof c==="string"?(a.template[c]=b):b}return c?typeof c!=="string"?a.template(null,c):a.template[c]||a.template(null,q.test(c)?c:a(c)):null},encode:function(a){return(""+a).split("<").join("&lt;").split(">").join("&gt;").split('"').join("&#34;").split("'").join("&#39;")}});a.extend(a.tmpl,{tag:{tmpl:{_default:{$2:"null"},open:"if($notnull_1){_=_.concat($item.nest($1,$2));}"},wrap:{_default:{$2:"null"},open:"$item.calls(_,$1,$2);_=[];",close:"call=$item.calls();_=call._.concat($item.wrap(call,_));"},each:{_default:{$2:"$index, $value"},open:"if($notnull_1){$.each($1a,function($2){with(this){",close:"}});}"},"if":{open:"if(($notnull_1) && $1a){",close:"}"},"else":{_default:{$1:"true"},open:"}else if(($notnull_1) && $1a){"},html:{open:"if($notnull_1){_.push($1a);}"},"=":{_default:{$1:"$data"},open:"if($notnull_1){_.push($.encode($1a));}"},"!":{open:""}},complete:function(){b={}},afterManip:function(f,b,d){var e=b.nodeType===11?a.makeArray(b.childNodes):b.nodeType===1?[b]:[];d.call(f,b);m(e);c++}});function i(e,g,f){var b,c=f?a.map(f,function(a){return typeof a==="string"?e.key?a.replace(/(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g,"$1 "+d+'="'+e.key+'" $2'):a:i(a,e,a._ctnt)}):e;if(g)return c;c=c.join("");c.replace(/^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/,function(f,c,e,d){b=a(e).get();m(b);if(c)b=j(c).concat(b);if(d)b=b.concat(j(d))});return b?b:j(c)}function j(c){var b=document.createElement("div");b.innerHTML=c;return a.makeArray(b.childNodes)}function o(b){return new Function("jQuery","$item","var $=jQuery,call,_=[],$data=$item.data;with($data){_.push('"+a.trim(b).replace(/([\\'])/g,"\\$1").replace(/[\r\t\n]/g," ").replace(/\$\{([^\}]*)\}/g,"").replace(/\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,function(m,l,j,d,b,c,e){var i=a.tmpl.tag[j],h,f,g;if(!i)throw"Template command not found: "+j;h=i._default||[];if(c&&!/\w$/.test(b)){b+=c;c=""}if(b){b=k(b);e=e?","+k(e)+")":c?")":"";f=c?b.indexOf(".")>-1?b+c:"("+b+").call($item"+e:b;g=c?f:"(typeof("+b+")==='function'?("+b+").call($item):("+b+"))"}else g=f=h.$1||"null";d=k(d);return"');"+i[l?"close":"open"].split("$notnull_1").join(b?"typeof("+b+")!=='undefined' && ("+b+")!=null":"true").split("$1a").join(g).split("$1").join(f).split("$2").join(d?d.replace(/\s*([^\(]+)\s*(\((.*?)\))?/g,function(d,c,b,a){a=a?","+a+")":b?")":"";return a?"("+c+").call($item"+a:d}):h.$2||"")+"_.push('"})+"');}return _;")}function n(c,b){c._wrap=i(c,true,a.isArray(b)?b:[q.test(b)?b:a(b).html()]).join("")}function k(a){return a?a.replace(/\\'/g,"'").replace(/\\\\/g,"\\"):null}function s(b){var a=document.createElement("div");a.appendChild(b.cloneNode(true));return a.innerHTML}function m(o){var n="_"+c,k,j,l={},e,p,i;for(e=0,p=o.length;e<p;e++){if((k=o[e]).nodeType!==1)continue;j=k.getElementsByTagName("*");for(i=j.length-1;i>=0;i--)m(j[i]);m(k)}function m(j){var p,i=j,k,e,m;if(m=j.getAttribute(d)){while(i.parentNode&&(i=i.parentNode).nodeType===1&&!(p=i.getAttribute(d)));if(p!==m){i=i.parentNode?i.nodeType===11?0:i.getAttribute(d)||0:0;if(!(e=b[m])){e=f[m];e=g(e,b[i]||f[i],null,true);e.key=++h;b[h]=e}c&&o(m)}j.removeAttribute(d)}else if(c&&(e=a.data(j,"tmplItem"))){o(e.key);b[e.key]=e;i=a.data(j.parentNode,"tmplItem");i=i?i.key:0}if(e){k=e;while(k&&k.key!=i){k.nodes.push(j);k=k.parent}delete e._ctnt;delete e._wrap;a.data(j,"tmplItem",e)}function o(a){a=a+n;e=l[a]=l[a]||g(e,b[e.parent.key+n]||e.parent,null,true)}}}function u(a,d,c,b){if(!a)return l.pop();l.push({_:a,tmpl:d,item:this,data:c,options:b})}function w(d,c,b){return a.tmpl(a.template(d),c,b,this)}function x(b,d){var c=b.options||{};c.wrapped=d;return a.tmpl(a.template(b.tmpl),b.data,c,b.item)}function v(d,c){var b=this._wrap;return a.map(a(a.isArray(b)?b.join(""):b).filter(d||"*"),function(a){return c?a.innerText||a.textContent:a.outerHTML||s(a)})}function t(){var b=this.nodes;a.tmpl(null,null,null,this).insertBefore(b[0]);a(b).remove()}})(jQuery)

/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
/* comment  Hd 19/02/2024 & cookies set javascript fucntion
$(function () {
   jQuery.cookie=function(c,e,a){if("undefined"!=typeof e){a=a||{};null===e&&(e="",a.expires=-1);var d="";a.expires&&("number"==typeof a.expires||a.expires.toUTCString)&&("number"==typeof a.expires?(d=new Date,d.setTime(d.getTime()+864E5*a.expires)):d=a.expires,d="; expires="+d.toUTCString());var f=a.path?"; path="+a.path:"",g=a.domain?"; domain="+a.domain:"";a=a.secure?"; secure":"";document.cookie=[c,"=",encodeURIComponent(e),d,f,g,a].join("")}else{e=null;if(document.cookie&&""!=document.cookie)for(a=
  document.cookie.split(";"),d=0;d<a.length;d++)if(f=jQuery.trim(a[d]),f.substring(0,c.length+1)==c+"="){e=decodeURIComponent(f.substring(c.length+1));decodeURIComponent(f.substring(c.length+1));break}return e}};
});*/
/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function deleteCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
 
function getVariantColorImage(data,color,disallow){/*hd updated 28/09/2020 */
    var imageurl = [];
   
  
      for(var j=0;j<data.length;j++){
        var alt_low = null;      
        if(data[j].alt){
           alt_low =  data[j].alt.toLowerCase();
        }
        if(color!=null && alt_low!=null && data[j].media_type=="image"){
          
          if(disallow!=0 && alt_low.indexOf(disallow) != -1){
          	
            //console.log(alt_low+"====="+color+"================"+disallow);
            //console.log(alt_low.indexOf(disallow));
          }
          else if(alt_low.indexOf(color.toLowerCase()) > -1){
            
            imageurl= data[j].id;
            break;  
          }
          
        }           
   	}
    if(imageurl.length == 0){
      for(var j=0;j<data.length;j++){
      	var alt_low = null;      
        if(data[j].alt){
          alt_low =  data[j].alt.toLowerCase();
        }
        if(color!=null && alt_low!=null && data[j].media_type=="image"){
          
           
          if(disallow!=0 && alt_low.indexOf(disallow) != -1){
          	
            //console.log(alt_low+"====="+color+"================"+disallow);
            //console.log(alt_low.indexOf(disallow));
          }
          else if(alt_low.indexOf(color.toLowerCase()) > -1){
            
            imageurl= data[j].id;
            break;  
          }
        }           
   	  }
    }
    return (imageurl !="")?imageurl:data[0].id;
}
function getReviewsRate(handle){
  // $.ajax({
  //     type: 'GET',
  //     url: 'https://www.intotheam.com/products/'+handle,
  //     beforeSend: function() {},
  //     success: function (data) {
  //       var $newDom = $('<div>' + data + '</div>');
  //       var review_rate_html = $newDom.find('.reviews-questions').html();	
  //       return review_rate_html;
  //     }
  //   });

  $.get('https://www.intotheam.com/products/'+handle, function(data) {
    var $newDom = $('<div>' + data + '</div>');
    var review_rate_html = $newDom.find('.reviews-questions').html();	
    
    return review_rate_html;
  });
}
$(function () {
Shopify.Products = (function () {
    
    var a = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        wrapperClass: "recently-viewed-products",
        templateId: "recently-viewed-product-template",
        onComplete: null
    };
    var c = [];
    var h = null;
    var d = null;
    var e = 0;
    var b = {
        configuration: {
            expires: 90,
            path: "/",
            domain: window.location.hostname
        },
        name: "shopify_recently_viewed",
        write: function (i) {
            //jQuery.cookie(this.name, i.join(" "), this.configuration)
            setCookie(this.name,i.join(" "),90)
        },
        read: function () {
            var i = [];
            //var j = jQuery.cookie(this.name);
            var j = getCookie(this.name);
            if (j !== null) {
                i = j.split(" ")
            }
            return i
        },
        destroy: function () {
            //jQuery.cookie(this.name, null, this.configuration)
            deleteCookie(this.name);
        },
        remove: function (k) {
            var j = this.read();
            var i = jQuery.inArray(k, j);
            if (i !== -1) {
                j.splice(i, 1);
                this.write(j)
            }
        }
    };
    var f = function () {
  		
        h.show();
        $('.slide_cart_inner #recently-viewed-products a').click(function(e){
          if(typeof gtag != "undefined")
             gtag('event', 'Slideout Cart Tracking', {'event_category': 'slide out cart','event_label': 'empty-cart-recently-viewed','value': 'Empty Cart: Recently Viewed'});
        });
        if (a.onComplete) {
            try {
                a.onComplete()
            } catch (i) {}
        }
    };
    var getSecondaryProduct = function (i,h,c,callbackFn,reviewsHtml) {
       var tags = i.tags;
        var temp_data = i;
        for(var m = 0;m < tags.length; m++){
          if(tags[m].indexOf('collectionSwatch_') != -1){
            const collection_hendle = tags[m].split('collectionSwatch_');
            if(collection_hendle && collection_hendle[1]){
              var hendle = collection_hendle[1];
              
              $.getJSON('/collections/'+hendle+'/products.json', function(response) {
                if(response.products.length > 1){  
                  
                   $.getJSON("/products/" + response.products[1].handle + ".js", function(response) {
                      
                      $.each(response.variants, function(index, element) {
                      if(element && element.id > 0){temp_data.variants.push(element);}
                      });
                      $.each(response.media, function(index, element03) {
                      if(element03 && element03.id > 0){temp_data.media.push(element03);}
                      });
                      callbackFn(temp_data,h,c,reviewsHtml);
                  });
                }
               });
            }
          }
        } 
      };
    var findReviewRate = function(i,h,c){
      $.ajax({
          type: 'GET',
          url: 'https://www.intotheam.com/products/'+i.handle,
          beforeSend: function() {},
          success: function (data) {
            var $newDom = $('<div>' + data + '</div>');
            //return $newDom.find('.reviews-questions').html();	
            $newDom.find('.stamped-product-reviews-badge').removeClass('stamped-main-badge');
            var reviewsHtml = $newDom.find('.reviews-questions').html();
            
            //return html;
            if($.inArray("primary-product", i.tags) !== -1){
              getSecondaryProduct(i,h,c,callbackSecondaryProduct,reviewsHtml);
            } else {
              callbackSecondaryProduct(i,h,c,reviewsHtml);
            }
          }
      });
    }
      
    var callbackSecondaryProduct = function(i,h,c,reviewsHtml){
      var featured_image_url = "https:"+i.featured_image; 
      var variant 	=  i.variants;
      var options 	=  i.options;
      var media  	=  i.media;
      var featured_media_id = [];
      var is_plus	= 0;
      var disallow 	= "";
      var newArray  = [];
      var is_show_watch = '';
      
      if(options[0] && options[0].name){
        if(options[0].name!= "Color" && options[0].name!= "color"){
          is_show_watch = 'hidden';
        }
      }
      variant.forEach(function(variants) {
        newArray.push(variants.option1);
      });
      
      Array.prototype.unique = function () {
        var arr = this;
        return $.grep(arr, function (v, i) {
          return $.inArray(v, arr) === i;
        });
      }             
      var remain_swatch = newArray.unique().length - 3;
      var settings_prod_thumb_crop = true;
      var html = '';
      var tagsArray = $.trim(i['tags']).split(",");
          tagsArray = tagsArray.map(function(v) {return v.toLowerCase();});

      tag_ = $.trim(tag_).toLowerCase();
      var msg_temp = '';
      if($.inArray(tag_,tagsArray) >= 0 && is_show_msg == 'true'){   
        var msg_temp = msg_1;
      }

      tag_2 = $.trim(tag_2).toLowerCase();
      var msg_temp_2 = '';
      if($.inArray(tag_2,tagsArray) >= 0 && is_show_msg_2 == 'true' ){   
        var msg_temp_2 = msg_2;
      }

      var p_badges ='<div class="product_badges">';     
        
        if($.inArray('custombundle',tagsArray) >= 0){   
              p_badges += '<span class="custom_badges">Custom</span>';                         
          }
        if($.inArray('active',tagsArray) >= 0){
            p_badges += '<span class="custom_badges">Active</span>'; 
        }
        
        if($.inArray('new-item',tagsArray) >= 0 ){
          p_badges += '<span class="custom_badges new_tag">New</span>';
        }
        if (i.title.toLocaleLowerCase().indexOf("pack") < -1 || i.title.toLocaleLowerCase().indexOf("packs") < -1){
        if($.inArray('low in stock',tagsArray) >= 0){
              p_badges += '<span class="custom_badges">Low Stock</span>';
        }
        }
        if($.inArray('exclusive',tagsArray) >= 0 ){
          p_badges += '<span class="custom_badges">Exclusive</span>';
        }
        
        if($.inArray('web best sellers',tagsArray) >= 0){
          p_badges += '<span class="custom_badges">Best Sellers</span>';
        }
        if($.inArray('pre-order',tagsArray) >= 0){
          p_badges += '<span class="custom_badges">Pre-Order</span>';
        }
  
        p_badges +='</div>';
      
      if(newArray.unique().length >= 2){
          var truncated ='';
          var image_active= "";
          var image_on_hover = "";
        
          html += '<div class="recently-product-block column--quarter product-block" data-product-id="'+i.id+'">';
          html += '<div class="block-inner">';
          if(customer_active){
            html += '<div class="relative product_image"><div class="coll_wishlist hidden"><!-- include "wishlist-button-collection" with '+i.id+' --></div>'; /*udate line AP 05/09/2022*/
          }else{
              html += "<div class='relative product_image '><div class='coll_wishlist'><span class='wishlist_product_button' data-product-id="+i.id+"><!-- include 'wishlist-button-collection' with "+i.id+" --> </span></div>";        
          }
          html += '<div class="block-inner-inner">';
          
          html += '<div class="image-cont image-cont--with-secondary-image ">';
        if(i.compare_at_price_max){                      	
          var discountRaw = (i.compare_at_price - i.price) * 100 / i.compare_at_price;
          var discountPercent = Math.round(discountRaw);
        
          var priceNow = theme.Shopify.formatMoney(i.price, theme.money_format).replace(/<[^>]*>?/gm, '');
          var priceWas = theme.Shopify.formatMoney(i.compare_at_price, theme.money_format).replace(/<[^>]*>?/gm, '');
        
          var ariaLabel = 'Up to -' + discountPercent + '% ' + i.title + ', Now ' + priceNow + ', Was ' + priceWas + ', Save ' + discountPercent + '%.';
        } else {
          var priceNow = theme.Shopify.formatMoney(i.price, theme.money_format).replace(/<[^>]*>?/gm, '');
          var ariaLabel = i.title + ', Now ' + priceNow;
        }
          html += '<a class="product-link" href="'+i.url+'" aria-label="'+ariaLabel+'" data-handle="'+i.handle+'">';
          
          if(featured_image_url == media[0].src){
            image_active ="product-block__image--active";
          }
        
          if( media.length > 0 && featured_image_url == media[media.length-1].src){
            image_on_hover = 'product-block__image--show-on-hover';
          } 
        
          html +='<div class="image-label-wrap"><div>';
            
          if(i.compare_at_price_max){                      
            var sale_price_per = (i.compare_at_price-i.price)*100;
            sale_price_per = sale_price_per/i.compare_at_price;
            html +='<div class="product-discount-percentage" data-sale-price="" data-current=""> -'+ sale_price_per.toFixed(0) + '%</div>';
          } 
        
          html +='<div class="product-block__image product-block__image--primary '+image_active+' '+image_on_hover+'" data-media-id='+media[0].id+'>';
          html +='<div class="rimage-outer-wrapper">';
         
          html +='<div class="rimage-wrapper" style="padding-top: 125%;">';
          html +='<img src="//www.intotheam.com/cdn/shop/files/loader.gif" data-src="'+Shopify.Products.resizeImage(i.featured_image, "large")+'" alt="'+i.title+'" data-expand="110" class="lazyload rimage__image fade-in cover lazyautosizes">';
          html +='</div>';
          html +='</div>';
          html +='</div>';
        
          var active_media_found = true;
          var img_count =0;
        
          for(var j=1;j<media.length;j++){
            
            if(media[j].media_type !='video' && media[j].src !=""){
               
              var image_state_class ='';
              
              if(featured_image_url == media[j].src){
                image_state_class = 'product-block__image--active';

              }else{
                if (active_media_found){
                    active_media_found = false;
                    image_state_class = 'product-block__image--show-on-hover';
                }
              }
              var is_cover = '';
              var fit = 'contain';
              if(settings_prod_thumb_crop){
                is_cover = 'cover';
                fit = 'cover';
              }

              html +='<div class="product-block__image product-block__image--secondary '+image_state_class+' rimage-wrapper" data-media-id="'+media[j].id+'" data-image-index="'+j+'">';
              html +='<div class="rimage-background fade-in '+is_cover+'" data-parent-fit="'+fit+'" data-lazy-bgset-src="'+Shopify.Products.resizeImage(media[j].src, "large")+'" data-sizes="auto"">';
              html +='<img src="'+Shopify.Products.resizeImage(media[j].src, "large")+'" alt="'+i.title+'" class="rimage__image">';
              html +='</div></div>';
              
            }
          }
        
          html += '</div>';
          html += '</div>';                      
          html += '</a>';
        
         
            
               /*html += '<a class="btn btn--secondary quickbuy-toggle" href="'+i.url+'">+ Quick Add</a>';*/
          var title_handle = i.handle;
          
            
          
            html += '</div>';
        
        /* AP added for product badges 05-07-2023 start */
        /* code repeated use optimze by hd 20/12/2023 */
             html += p_badges
        
        /* AP added for product badges 05-07-2023 end */
        
            html += '<div class="product-info">';
            html += '<div class="inner">';
            html += '<div class="innerer">';
            html += '<div class="product-block__title">'+i.title+'</div>';
            html += '<div class="product-price recent-product-price">';
            if(i.compare_at_price_max){
              if(list_eur_currancy.includes(loc_iso_code)){
                var formated_price = theme.Shopify.formatMoney(i.price, theme.money_format)
                var final_price = (i.price / 100);
                if (final_price > 1000){
                  formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.').replace(/.([^,]*)$/, '$1');
                }else{
                  formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.');
                }
                html += '<span class="product-price__item price theme-money product-price__amount--on-sale"><span class="money">'+ formated_price +'</span></span>';
              }else{
                html += '<span class="product-price__item price theme-money product-price__amount--on-sale"><span class="money">'+ theme.Shopify.formatMoney(i.price, theme.money_format) +'</span></span>';
              }
              html += '<span class="product-price__item res_was_price product-price__compare theme-money">';
              if(list_eur_currancy.includes(loc_iso_code)){
                var formated_price = theme.Shopify.formatMoney(i.compare_at_price, theme.money_format)
                var final_price = (i.compare_at_price / 100);
                if (final_price > 1000){
                  formated_price =  theme.Shopify.formatMoney(i.compare_at_price, theme.money_format).replace(/,/, '.').replace(/.([^,]*)$/, '$1');
                }else{
                  formated_price =  theme.Shopify.formatMoney(i.compare_at_price, theme.money_format).replace(/,/, '.');
                }
                html += '<span class="money">'+formated_price +'</span>';
              }else{
                html += '<span class="money">'+theme.Shopify.formatMoney(i.compare_at_price, theme.money_format) +'</span>';
              }
              html += '</span>';
          }else{
            if(list_eur_currancy.includes(loc_iso_code)){
              var formated_price = theme.Shopify.formatMoney(i.price, theme.money_format)
              var final_price = (i.price / 100);
              if (final_price > 1000){
                formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.').replace(/.([^,]*)$/, '$1');
              }else{
                formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.');
              }
              html += '<span class="product-price__item price theme-money"><span class="money">'+ formated_price+'</span></span>';
            }else{
              html += '<span class="product-price__item price theme-money"><span class="money">'+ theme.Shopify.formatMoney(i.price, theme.money_format) +'</span></span>';
            }
          }
          if(reviewsHtml!=undefined){
             html += reviewsHtml;
          }
          html += '</div>';
          if(msg_temp != '' ){
            html += msg_temp;
          }
          if(msg_temp_2 != '' ){
            html += msg_temp_2;
          }
           //html += '<div class=" product-block-options product-block-options--swatch" data-option-name="Color">';
           html += '<div class=" product-block-options product-block-options--swatch '+is_show_watch+'" data-option-name="Color">';
          html += '<div class="product-block-options__inner">';
    
          //console.log("disallow------",disallow);
          
          $.each(newArray.unique() , function( key, value ){
            if(key > 2){
              truncated = 'product-block-options__item--truncated';
            } 
            var lowerColor = value.toLowerCase();
            var imageCount = 0;
            
            for(var j=0;j<media.length;j++){
                if(lowerColor!=null && media[j]['alt']!=null){
                  if(media[j]['alt'].includes(lowerColor) || media[j]['alt'].toLowerCase().includes(lowerColor)){
                    imageCount++;
                  }
                }           
             }
              disallow =0;
              $.each(newArray.unique() , function( key1, value1 ){
                value = value.toLowerCase();
                value1= value1.toLowerCase();
                if(value1.indexOf(value) != -1 && value != value1){
                  disallow = value1;
                }
              });
              var media_img =  getVariantColorImage(media,lowerColor,disallow);
              
            
             html += '<span class="recently-viewed product-block-options__item lazyload '+truncated+' " data-image-count="'+imageCount+'"  data-option-item="'+lowerColor+'" data-media="'+media_img+'" data-swatch="'+lowerColor+'">';
             html += '</span>';
          });
        
          if(remain_swatch > 0){
            html += '<span class="product-block-options__more-label">+ '+remain_swatch+' more</span>';
          }	   
        html += '</div></div>';
          html += '</div></div></div></div></div>';
         html +='</div>';var aria_label = "Closed";
                html +='<div class="quickbuy-container">';
                html +='<a href="#" class="close-detail" aria-label="'+aria_label+'" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>';
                html +='<div class="inner"></div>';
                html +='</div>';}else{

        var truncated ='';
        var image_active= "";
        var image_on_hover = "";

        html += '<div class="recently-product-block column--quarter product-block" data-product-id="'+i.id+'">';
        html += '<div class="block-inner">';
        if(customer_active){
            html += '<div class="relative product_image"><div class="coll_wishlist hidden"><!-- include "wishlist-button-collection" with '+i.id+' --></div>'; /*udate line AP 05/09/2022*/
          }else{
              html += "<div class='relative product_image '><div class='coll_wishlist'><span class='wishlist_product_button' data-product-id="+i.id+"><!-- include 'wishlist-button-collection' with "+i.id+" --> </span></div>";        
        }
        html += '<div class="block-inner-inner">';

        html += '<div class="image-cont image-cont--with-secondary-image ">';
         if(i.compare_at_price_max){                      	
          var discountRaw = (i.compare_at_price - i.price) * 100 / i.compare_at_price;
          var discountPercent = Math.round(discountRaw);
          var priceNow = theme.Shopify.formatMoney(i.price, theme.money_format).replace(/<[^>]*>?/gm, '');
          var priceWas = theme.Shopify.formatMoney(i.compare_at_price, theme.money_format).replace(/<[^>]*>?/gm, '');
          var ariaLabel = 'Up to -' + discountPercent + '% ' + i.title + ', Now ' + priceNow + ', Was ' + priceWas + ', Save ' + discountPercent + '%.';
        } else {
          var priceNow = theme.Shopify.formatMoney(i.price, theme.money_format).replace(/<[^>]*>?/gm, '');
          var ariaLabel = i.title + ', Now ' + priceNow;
        }
        html += '<a class="product-link" href="'+i.url+'" aria-label="'+i.title+'"  data-handle="'+i.handle+'">';
        
        if(featured_image_url == media[0].src){
          image_active ="product-block__image--active";
        }
        if( media.length > 0 && featured_image_url == media[media.length-1].src){
          image_on_hover = 'product-block__image--show-on-hover';
        }                      
        html += '<div class="image-label-wrap">';
        html += '<div>';
        if(i.compare_at_price_max){                      	
            var sale_price_per = (i.compare_at_price-i.price)*100;
            sale_price_per = sale_price_per/i.compare_at_price;
            html +='<div class="product-discount-percentage" data-sale-price="'+ i.compare_at_price +'" data-current="'+ i.price +'"> -'+  sale_price_per.toFixed(0) + ' %</div>';
          } 
        html +='<div class="product-block__image product-block__image--primary '+image_active+' '+image_on_hover+'" data-media-id='+media[0].id+'>';
        html +='<div class="rimage-outer-wrapper">';
      
        html +='<div class="rimage-wrapper" style="padding-top: 125%;">';
        html += '<img src="//www.intotheam.com/cdn/shop/files/loader.gif" data-src="'+Shopify.Products.resizeImage(i.featured_image, "large")+'" alt="'+i.title+'" data-expand="110" class="lazyload rimage__image fade-in cover lazyautosizes">';
        html +='</div></div></div>';
        
        var active_media_found = true;
        
        for(var j=1;j<media.length;j++){
          var image_state_class ='';
          if(featured_image_url == media[j].src){
            image_state_class = 'product-block__image--active';
          }else{
            if (active_media_found){
              active_media_found = false;
              image_state_class = 'product-block__image--show-on-hover';
            }
          }
          var is_cover = '';
          var fit = 'contain';
          if(settings_prod_thumb_crop){
            is_cover = 'cover';
            fit = 'cover';
          }
          html +='<div class="product-block__image product-block__image--secondary rimage-wrapper '+image_state_class+'" data-media-id="'+media[j].id+'" data-image-index="'+j+'">';
          html +='<div class="rimage-background fade-in '+is_cover+'" data-parent-fit="'+fit+'" data-lazy-bgset-src="'+Shopify.Products.resizeImage(media[j].src, "large")+'" data-sizes="auto"">';
          html +='<img src="'+Shopify.Products.resizeImage(media[j].src, "large")+'" alt="'+i.title+'" class="rimage__image">';
          html +='</div></div>';
        }
        
        html += '</div>';
        html += '</div>';                    
        html += '</a>';

        
        
        
        
         var title_handle = i.handle;
        
        
         
        html += '</div>';
        
      /* AP added for product badges 20-4-2023 start */
       
        
          /* code repeated use optimze by hd 20/12/2023 */
            html += p_badges;
        
        /* AP added for product badges 20-4-2023 end */
          html += '<div class="product-info">';
          html += '<div class="inner">';
          html += '<div class="innerer">';
          html += '<div class="product-block__title">'+i.title+'</div>';
          html += '<div class="product-price recent-product-price">';
          if(i.compare_at_price_max){
            if(list_eur_currancy.includes(loc_iso_code)){
              var formated_price = theme.Shopify.formatMoney(i.price, theme.money_format)
              var final_price = (i.price / 100);
              if (final_price > 1000){
                formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.').replace(/.([^,]*)$/, '$1');
              }else{
                formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.');
              }
              html += '<span class="product-price__item price theme-money product-price__amount--on-sale"><span class="money">'+ formated_price +'</span></span>';
            }else{
              html += '<span class="product-price__item price theme-money product-price__amount--on-sale"><span class="money">'+ theme.Shopify.formatMoney(i.price, theme.money_format) +'</span></span>';
            }
            html += '<span class="product-price__item res_was_price product-price__compare theme-money">';
            if(list_eur_currancy.includes(loc_iso_code)){
              var formated_price = theme.Shopify.formatMoney(i.compare_at_price, theme.money_format)
              var final_price = (i.compare_at_price / 100);
              if (final_price > 1000){
                formated_price =  theme.Shopify.formatMoney(i.compare_at_price, theme.money_format).replace(/,/, '.').replace(/.([^,]*)$/, '$1');
              }else{
                formated_price =  theme.Shopify.formatMoney(i.compare_at_price, theme.money_format).replace(/,/, '.');
              }
              html += '<span class="money">'+formated_price +'</span>';
            }else{
              html += '<span class="money">'+theme.Shopify.formatMoney(i.compare_at_price, theme.money_format) +'</span>';
            }
          html += '</span>';
         }else{
          if(list_eur_currancy.includes(loc_iso_code)){
            var formated_price = theme.Shopify.formatMoney(i.price, theme.money_format)
            var final_price = (i.price / 100);
            if (final_price > 1000){
              formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.').replace(/.([^,]*)$/, '$1');
            }else{
              formated_price =  theme.Shopify.formatMoney(i.price, theme.money_format).replace(/,/, '.');
            }
            html += '<span class="product-price__item price theme-money"><span class="money">'+ formated_price+'</span></span>';
          }else{
            html += '<span class="product-price__item price theme-money"><span class="money">'+ theme.Shopify.formatMoney(i.price, theme.money_format) +'</span></span>';
          }
        }
        if(reviewsHtml!=undefined){
         html += reviewsHtml;
        }
        html += '</div>';
        if(msg_temp != '' ){
            html += msg_temp;
        }
        if(msg_temp_2 != '' ){
            html += msg_temp_2;
        }
        html += '</div></div></div></div></div>';
        html +='</div>';var aria_label = "Closed";
        html +='<div class="quickbuy-container">';
        html +='<a href="#" class="close-detail" aria-label="'+aria_label+'" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>';
        html +='<div class="inner"></div>';
        html +='</div>';} 

      $(h).append(html);                    
      c.shift();
      e++;
      g();
      //wishlist_Content();
      $('.recently-view-title').show();     
    }
  
    var g = function () {
        
        if (c.length && e < a.howManyToShow) {
          /*if(c[0] != h.attr('data-pid')){ hd add code for protection product hide */
          if(c[0] != h.attr('data-pid') && c[0] != 'green-package-protection'){ 
            
            
            jQuery.ajax({
                dataType: "json",
                url: "/products/" + c[0] + ".js",
                cache: false,
                success: function (i) {
                  findReviewRate(i,h,c);
                  
                  // if($.inArray("primary-product", i.tags) !== -1){
                  //   getSecondaryProduct(i,h,c,callbackSecondaryProduct);
                  // } else {
                  //   callbackSecondaryProduct(i,h,c);
                  // }

                  //// moved to callbackSecondaryProduct
                                   
                },
                error: function () {
                    b.remove(c[0]);
                    c.shift();
                    g()
                }
            })
             }else{c.shift();e++;a.howManyToShow = a.howManyToShow +1;g();}
        } else {
            f()
        }
    };
    return {
      
        resizeImage: function (m, j) {
          	
            if (j == null) {
                return m
            }
            if (j == "master") {
                return m.replace(/http(s)?:/, "")
            }
           if(m !=undefined && m !=''){ /*hd 06/06/22 src must be not empty*/ 
             
             var i = m.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
             if (i != null) {
               var k = m.split(i[0]);
               var l = i[0];
               return (k[0] + "_" + j + l)
               .replace(/http(s)?:/, "")
             } else {
               return null
             }
           }
        },
        showRecentlyViewed: function (i) {
           
            var i = i || {};
            jQuery.extend(a, i);
            c = b.read();
            d = jQuery("#" + a.templateId);
            h = jQuery("." + a.wrapperClass);
            a.howManyToShow = Math.min(c.length, a.howManyToShow);
            if (a.howManyToShow && d.length && h.length) {
                g()
            }
        },
        getConfig: function () {
            return a
        },
        clearList: function () {
            b.destroy()
        },
        recordRecentlyViewed: function (l) {
          	
            var l = l || {};
            jQuery.extend(a, l);
            var j = b.read();
            if (window.location.pathname.indexOf("/products/") !== -1) {
                var k = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                var i = jQuery.inArray(k, j);
                if (i === -1) {
                    j.unshift(k);
                    j = j.splice(0, a.howManyToStoreInMemory)
                } else {
                    j.splice(i, 1);
                    j.unshift(k)
                }
                b.write(j)
            }
        }
    }
})(); 
}); 